import React, { ReactElement } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export interface ImageField {
  src?: string;
  alt?: string;
  height?: string;
  width?: string;
  loading?: string;
}

interface LazyLoadingProps {
  field: { value: ImageField };
  cssClass?: string;
  id?: string;
}

const LazyLoading: (props: LazyLoadingProps) => ReactElement = (props) => {
  return (
    <div
      className={props.cssClass && props.cssClass}
      style={{ width: '100%', height: '100%' }}
    >
      <Image
        key={props.field?.value && props.field?.value?.alt}
        field={{ ...props.field }}
        loading={'lazy'}
      />
    </div>
  );
};

export default LazyLoading;
